// extracted by mini-css-extract-plugin
module.exports = {"container":"Title_container__2xO5a","text":"Title_text__2ogqB","secondaryText":"Title_secondaryText__1Gfhu","small":"Title_small__1uv6p","header":"Title_header__2oUHg"};